export default __webpack_public_path__ + "img/edxkKXkB.0533001a.svg";